module.exports = __webpack_public_path__ + "static/media/industry.79bc8b74.svg";